import {
  GenericActionResponse,
} from "../../src/@types";
import {
  UsuariosApiResponse,
  UsuarioEdicaoRequest,
} from "../../src/@types/usuarios";
import apiAutenticacao from "./api-autenticacao.service";

export function obterUsuarios(): Promise<UsuariosApiResponse> {
  return apiAutenticacao.get("/usuarios?sistema=PTAX");
}

export function obterUsuariosPorTextoDeBusca(textoBusca: string): Promise<UsuariosApiResponse> {
  return apiAutenticacao.get(`/usuarios/buscar-por-campos?textoDeBusca=${textoBusca}&sistema=PTAX`);
}

export function cadastrarUsuario(usuario: UsuarioEdicaoRequest): Promise<GenericActionResponse> {
  return apiAutenticacao.post("/usuarios/", usuario);
}

export function atualizarUsuario(id: number, usuario: UsuarioEdicaoRequest): Promise<GenericActionResponse> {
  return apiAutenticacao.put(`/usuarios/${id}`, usuario);
}

export function excluirUsuario(id: number): Promise<GenericActionResponse> {
  return apiAutenticacao.delete(`/usuarios/${id}`);
}